import axiosClient from "./axiosClient";

export async function getWishlist() {
  const response = await axiosClient.get("/Wishlist");
  return response.data;
}

export async function addToWishlist(productId) {
  const response = await axiosClient.post("/Wishlist", { productId });
  return response.data;
}

export async function removeFromWishlist(productId) {
  await axiosClient.delete(`/Wishlist/${productId}`);
}
